import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPhone, FiMail, FiMapPin, FiFacebook, FiTwitter, FiInstagram } = FiIcons;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      {/* Notice Section */}
      <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6 mx-4 mb-8 rounded-lg">
        <div className="max-w-6xl mx-auto">
          <p className="text-gray-800 text-sm leading-relaxed">
            <span className="text-yellow-600 font-semibold">⚠️ Notice:</span> This website is created only for student practice. Account4Web experts have not fixed technical issues here – so you can clearly see the real work level of students. Almost 80% of the website is perfect, and the remaining 20% is polished by experts in final projects. 
            <span className="text-green-600 font-semibold"> 🔒</span> We never share any client website made under this offer with others – your project privacy is 100% safe. 
            <a 
              href="https://projects.azaansuperpc.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-blue-600 hover:text-blue-800 font-semibold ml-2"
            >
              👉 Check Offer
            </a>
          </p>
        </div>
      </div>

      <footer className="bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {/* Logo & Description */}
            <div className="col-span-1 md:col-span-2">
              <div className="flex items-center space-x-2 mb-4">
                <img 
                  src="https://i.ibb.co/39wSX117/round-logo.png" 
                  alt="SmileCare Logo" 
                  className="h-10 w-10"
                />
                <span className="text-xl font-bold">SmileCare Dental</span>
              </div>
              <p className="text-gray-400 mb-6 max-w-md">
                Your trusted dental care provider committed to giving you the healthiest, most beautiful smile possible with state-of-the-art technology and compassionate care.
              </p>
              <div className="flex space-x-4">
                <a href="#" className="text-gray-400 hover:text-white transition-colors">
                  <SafeIcon icon={FiFacebook} className="w-5 h-5" />
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition-colors">
                  <SafeIcon icon={FiTwitter} className="w-5 h-5" />
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition-colors">
                  <SafeIcon icon={FiInstagram} className="w-5 h-5" />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
              <ul className="space-y-2">
                <li><Link to="/" className="text-gray-400 hover:text-white transition-colors">Home</Link></li>
                <li><Link to="/about" className="text-gray-400 hover:text-white transition-colors">About Us</Link></li>
                <li><Link to="/services" className="text-gray-400 hover:text-white transition-colors">Services</Link></li>
                <li><Link to="/gallery" className="text-gray-400 hover:text-white transition-colors">Gallery</Link></li>
                <li><Link to="/contact" className="text-gray-400 hover:text-white transition-colors">Contact</Link></li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
              <div className="space-y-3">
                <div className="flex items-center space-x-3">
                  <SafeIcon icon={FiPhone} className="w-5 h-5 text-blue-400" />
                  <span className="text-gray-400">(123) 456-7890</span>
                </div>
                <div className="flex items-center space-x-3">
                  <SafeIcon icon={FiMail} className="w-5 h-5 text-blue-400" />
                  <span className="text-gray-400">info@smilecare.com</span>
                </div>
                <div className="flex items-start space-x-3">
                  <SafeIcon icon={FiMapPin} className="w-5 h-5 text-blue-400 mt-1" />
                  <span className="text-gray-400">123 Dental Street<br />Your City, State 12345</span>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-8 pt-8 text-center">
            <p className="text-gray-400 text-sm">
              © {currentYear} SmileCare Dental. All rights reserved. | 
              <span className="ml-2">Domain + Hosting + Design = </span>
              <a 
                href="https://account4web.ca" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-400 hover:text-blue-300 ml-1"
              >
                Account4Web Inc
              </a>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;